import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SeoService } from '../../seo/seo.service';

@Component({
  standalone: true,
  selector: 'app-blog-prodotti-naturali',
  imports: [CommonModule, RouterModule],
  templateUrl: './pulire-casa-prodotti-naturali.html',
  styleUrls: ['./pulire-casa-prodotti-naturali.scss'],
})
export class BlogProdottiNaturaliComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Come pulire casa con prodotti naturali | SAMI Pulizie',
      description:
        'Scopri come pulire casa con prodotti naturali: aceto, bicarbonato, limone e oli essenziali. Guida pratica a Pescara.',
      keywords:
        'pulire casa prodotti naturali, pulizie ecologiche Pescara, pulizie naturali, detergenti naturali casa',
      canonicalUrl: '/blog/pulire-casa-prodotti-naturali',

      ogTitle: 'Come pulire casa con prodotti naturali',
      ogDescription:
        'Ingredienti naturali utili per pulire casa senza chimici aggressivi.',
      ogImage: '/assets/logo.png',
      ogType: 'article',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: 'Come pulire casa con prodotti naturali',
        description:
          'Guida pratica all’uso di prodotti naturali per pulire casa in modo efficace e sicuro.',
        datePublished: '2025-03-24',
        author: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
        },
        publisher: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
          logo: {
            '@type': 'ImageObject',
            url: 'https://samipulizie.it/assets/logo.png',
          },
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://samipulizie.it/blog/pulire-casa-prodotti-naturali',
        },
      },
    });
  }
}
